import type { SagGame } from '@ps/web-poker-tile-mappers';
import { useMemo } from 'react';

import type { CustomTile } from '../types';

export const useTopPrizeDisplay = (
  tile: SagGame,
  tileConfig: CustomTile | undefined,
  isActive: boolean
) =>
  useMemo(() => {
    const hasPromoPayouts = !!(tile.promoRef && tile.payoutAmount && tile.payoutAmountSelected);
    const hasConfigTopPrize = !!tileConfig?.topPrize;

    const displayCustomPrize = hasPromoPayouts || hasConfigTopPrize;

    let customPrizeValue: string | undefined;

    if (hasConfigTopPrize) {
      customPrizeValue = tileConfig.topPrize;
    } else if (hasPromoPayouts) {
      customPrizeValue = isActive ? tile.payoutAmountSelected : tile.payoutAmount;
    }

    const finalPrize = displayCustomPrize ? customPrizeValue : tile.winUpTo;

    return {
      displayCustomPrize,
      customPrizeValue,
      finalPrize
    };
  }, [tile, tileConfig, isActive]);
